import React from 'react';

import { VStack, Heading, Box } from '@chakra-ui/react';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';

import { CustomText } from '@components/Custom-text';

type MentorIconProps = {
    imageSrc: string | StaticImport;
    heading: string;
    text: string;
    isSingleLine?: boolean;
};
export const MenterInfoCard: React.FC<MentorIconProps> = ({
    imageSrc,
    heading,
    text,
    isSingleLine = false,
}) => (
    <VStack width="100%" align="center" justify="flex-start" px={4}>
        <Image src={imageSrc} alt="img" width={40} />
        <Heading fontSize="36px" lineHeight="40px" fontWeight={600} textAlign="center">
            {heading}
        </Heading>
        <CustomText color="#4B5563" textAlign="center" size="lg" lineHeight={1.56}>
            <span
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: text }}
            />
        </CustomText>
        {isSingleLine && (
            <Box visibility="hidden">
                <CustomText color="shadowSlate" textAlign="center" size="lg">
                    <span
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: text }}
                    />
                </CustomText>
            </Box>
        )}
    </VStack>
);
